import React from 'react';
import DropdownCalendarOld from 'components/Fields/ReduxForm/DropdownCalendarOld';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { changeDateFeedback } from 'actions/customers/feedback';
import styles from './ActionBar.css';
import MenuTitleLoyalty from '../../Loyalty/Components/MenuTitleLoyalty';

class ActionBar extends React.Component {
  render() {
    return (
      <div>
        <div className={`row ${styles['menu-title-loyalty-row']}`}>
          <MenuTitleLoyalty
            menuTitle="Feedback"
            loyaltySubscription={this.props.loyaltySubscription}
            goToSubscribeView={this.props.goToSubscribeView}
          />
        </div>
        <div className="row">
          <div className="col-sm-12 col-xs-8">
            <form className="form-inline" onSubmit={() => false}>
              <div className={`form-group ${styles['form-group']}`}>
                <Field
                  component={DropdownCalendarOld}
                  name="date"
                  onChange={this._onChangeDate}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  _onChangeDate = ({ startDate, endDate }) => {
    this.props.dispatch(changeDateFeedback(startDate, endDate));
    $('#customer-feedback').show();
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'search',
};

export default reduxForm(mapForm)(
  connect(
    null,
    mapDispatchToProps
  )(ActionBar)
);
